import { asks } from 'fp-ts/lib/Reader';
import { toRemoteData } from '../../utils/axios';
import * as qs from 'qs';
import { completeConnectResult, IntegrationType } from './integration.utils';
import { isDefined, mapRD } from '../../utils/object.utils';
export var slack = asks(function (_a) {
    var axios = _a.axios, _b = _a.domContext, getOrigin = _b.getOrigin, getQuery = _b.getQuery, slackClientId = _a.slackClientId;
    return slackClientId.map(function (slackClientId) {
        var makeRedirectUri = function () { return getOrigin() + "/export/slack"; };
        // const makeRedirectUri = () => `https://app.meetvolley.com/export/slack`;
        var connectSlack = function () {
            var query = {
                client_id: slackClientId,
                redirect_uri: makeRedirectUri(),
                scope: 'channels:read,channels:join,usergroups:read,groups:read,chat:write',
            };
            return {
                method: 'redirect',
                url: "https://slack.com/oauth/v2/authorize?" + qs.stringify(query),
            };
        };
        var completeConnectSlack = function () {
            return new Promise(function (resolve, reject) {
                var _a;
                var parsed = qs.parse((_a = getQuery()) !== null && _a !== void 0 ? _a : '');
                if (typeof parsed === 'object' &&
                    !!parsed &&
                    typeof parsed.code === 'string' &&
                    parsed.code.length > 0) {
                    resolve(completeConnectResult({
                        secrets: {
                            code: parsed.code,
                            redirect_uri: makeRedirectUri(),
                        },
                        config: {},
                        // notifications: {
                        //     note_create: false,
                        // },
                        routeParams: {
                            integrationType: IntegrationType.Slack,
                        },
                    }));
                }
                else {
                    reject(new Error('No authorization code in the request'));
                }
            });
        };
        var getChannels = function (productId, integrationId) {
            return toRemoteData(axios.get("/api/products/" + productId + "/integrations/" + integrationId + "/slack-channels")).pipe(mapRD(function (channels) {
                return channels
                    .map(function (ch) {
                    var _a;
                    return ch.channel_id
                        ? {
                            id: ch.channel_id,
                            name: (_a = ch.channel_name) !== null && _a !== void 0 ? _a : ch.channel_id,
                        }
                        : undefined;
                })
                    .filter(isDefined);
            }));
        };
        return {
            connect: connectSlack,
            completeConnect: completeConnectSlack,
            getChannels: getChannels,
        };
    });
});
//# sourceMappingURL=slack.service.js.map